/**
 * Manual mapping of ISRCs to YouTube video IDs.
 * These need to be researched and populated for each track.
 */
export const youtubeTrackMappings: Record<string, string> = {
  // ============ OPENING PHASE (15 tracks) ============
  'SEYTP1631301': '0Pod8J66fYA', // Opening - Trevor Oswalt, East Forest
  'CAM491100019': 'ZLorVraGc24', // Blue Drop - Ishq
  'CAM490010253': 'ADxY3lyq5eY', // Yu - Ishq
  'GBXYT1200009': 'rQZCkHGjYqg', // Photosynthesis - The Future Sound Of London
  'GBRDU0700015': 'IKPgk2ItTsw', // Early - Chicane
  'ushm91299125': 'Q2xPwx7GfwI', // Grandmothersphere - East Forest
  'GBXYT1200001': 'CkKX1LTzKvQ', // The Wheel Of Life - The Future Sound Of London
  'USMTD0233206': 'feeIShBaLP8', // Tone Twilight Zone - Cornelius
  'FR9W11805993': 'bx9pU27tnE0', // Snow Park - Remastered - Connect.Ohm
  'GBDDN0300113': 'TmIMJ1ZcB6Y', // Luna Moth - Jon Hopkins
  'USA2P0502897': 'hIoJb0BmoL4', // Exhalation - Shpongle
  'SE5Q51700532': 'Tq-1ZO7H6tY', // Next Time - Dovetail
  'TCABI1298704': 'JvljlbKsL2Y', // Sea of Oms - Morley
  'US2V90610012': 'gttW7C4L4vw', // Tibetan Gold - Steven Halpern
  'USEJB1100002': 'mlJTqWKRwnM', // Courage - Patrick O'Hearn

  // ============ BUILDING PHASE (22 tracks) ============
  'TCAAR1091259': 'NaENN285XSw', // Leaving Earth - Benn Jordan
  'QMFMG1321366': '3SezFa0P29c', // Protocol - Alucidnation
  'USA2P0722223': 'cyfpt4LpNAA', // Under Your Mind (Live version) - Cell
  'SEYOK1527626': 'IVrryq73HCE', // Vortex - Carbon Based Lifeforms
  'SEYOK1520347': '5AAbrmLOV8k', // Hydroponic Garden - Carbon Based Lifeforms, Yoji Ishida
  'TCAAW1164138': 'RjSawk_tXW4', // A Nice Little Place - Ott
  'GBMCZ0600601': '4CuJqtNdcJU', // Bubbles - Yosi Horikawa
  'GBKPL2020305': '5f9S8AX3NhU', // Deep Sea of Clouds - The Future Sound Of London
  'GBBPW9400048': 'TnIsku2bPYY', // #17 - Aphex Twin
  'USCCW1510481': 'V5PCuUQYKfw', // Sueno en Paraguay (El Buho Remix) - Chancha Via Circuito, El Búho
  'TCADZ1876030': '02gIZOcAsV0', // Aguas Claras - El Búho
  'TCADR1827273': 'Q5FCF_ZFku4', // Falling Up - Lucy Vincent
  'uscgh0630740': 'NiQQ0l4Othk', // City Of Safe Harbors - Port Blue
  'USA2P0609609': '8YEVrttbx1s', // Open Me Slowly - Rena Jones
  'US25X2003101': 'Bv1ReUVKd-w', // Surface Radiance - Bluetech
  'USWD12097243': '9j2iMxBesnw', // Falling - Trent Reznor and Atticus Ross
  'QZFYW1919680': 'ZFjQjOuEjQM', // Subtract - A.L.I.S.O.N
  'CAM490010252': 'xyVuW2s5SWQ', // Skyblue - Ishq
  'SE5IB1701723': 'ruF7BTzsptk', // Sens Plus Profond - Coquins
  'SEYOK1812698': 'bYyy38x7ty4', // Joshua's Shop - Solar Fields
  'usejb0630002': 'ypS1TIeMcGY', // So Flows the Current - Patrick O'Hearn
  'FR86W0400207': 'o9aDE0Mjz6w', // I Guess I'm Floating - M83

  // ============ PEAK PHASE (13 tracks) ============
  'SEYOK1422101': 'nT349_BbP-M', // Sky Trees - Solar Fields
  'SEYOK1422104': 'wINIhfVl9U0', // Das Bungalow - Solar Fields
  'SEYOK1422079': 'FpRBP-O6t-c', // Time Slide - Solar Fields
  'QZFYW2118294': 'KC8R_O0K-yc', // Rose Clouds - Moon Frog and mxxnwatchers Remix - DJ Taz Rashid, Momentology, Moon Frog, mxxnwatchers
  'ushm91455979': '4pj2LgJC9yo', // Toad Lick - East Forest
  'CZG961000007': 'UvDvawzJ3s8', // Mr. Handagote - Tomáš Dvořák
  'UKACT1540040': 'x0i4kahtMpg', // Galactic Zipline - Desert Dwellers Remix - Desert Dwellers, Luke Mandala
  'SEYOK1527625': 'xSqwNnnnRls', // Abiogenesis - Carbon Based Lifeforms
  'USI4R0707921': 'IQATFqFnCdg', // Broken Hope - Zero Cult
  'QMNRS2000004': 'TPUMSyqk7AM', // Precipitation - KiloWatts
  'USA2P1869996': 'Ohg42Ih2U7E', // Highland Step - Scott Nice, Evan Fraser
  'GBKQU1807431': 'p_wcC1l1cLk', // Paradise - Voyage
  'QZC5T1800017': '5Ox8lAG2SnA', // Forest - Equanimous

  // ============ LONG TAIL PHASE (33 tracks) ============
  'USDHM1504376': 'WJy7EHcmmpg', // Dreamlife - Tony Anderson
  'TCABR1313301': 'QhDv9Gwj5wI', // Going Home - Tom Day
  'BER571200072': 'tdMDgYUL0h8', // 1977 - Quentin Dujardin
  'USA2P1343313': 'DVCX6vlyMJY', // Phaeton Remains - Scann-Tec
  'SEYOK1507557': 'tfd2myOIIcc', // Frog - Carbon Based Lifeforms
  'GBDDN9900064': 'ewLCnJ9eU0o', // Inner Peace - Jon Hopkins
  'SEYOK1422105': 'TPIR2bThZPY', // Feelings - Edit - Solar Fields
  'US3DF1719624': 'pykvyT6eHLI', // Enchanted - Mars Lasar
  'USTC60852748': 'oAPDyfVXHBg', // Megan - Anesthesia
  'GBBBA1800070': 'oAhO5eegMfY', // re:member - Ólafur Arnalds
  'ushm81290757': 'JdNO1Wi6bQQ', // Inside - 36
  'DEU671201372': 'iJH2OppNb5g', // Pale Skin - Christian Löffler
  'GBXYT1200008': 'lg6Cad4bdzc', // Sunsets - The Future Sound Of London
  'SEYOK1527635': 'NTajW1JsnKE', // Betula Pendula - Carbon Based Lifeforms
  'NOBIP1802080': 'tIZ_G6QpeOk', // Sky Lounge - The Fires of Ork
  'TCABX1448331': '4l59c1mZUaI', // Nothing It Can - Helios
  'qmnrs1400007': 'HacxstXzARQ', // Living Stones - KiloWatts
  'CAM490010257': 'ByW7yuLBXYw', // Bhakti - Ishq
  'USQY51758381': 'Tee23uTvWEA', // Empty Jar - Phaeleh
  'USA4D0617601': 'niCMpOkMcWU', // I Can Almost See You - Hammock
  'BE6F59400130': 'O7gS1m24Ezk', // Singtree - Solar Quest
  'SEYOK1422106': 'SOZxyrJO62I', // Patterns - Solar Fields
  'GBXNG1744401': 'CUYboWbVe0A', // Two Thousand and Seventeen - Four Tet
  'TCABP1379116': 'VdXyrsFoeyc', // Clarity - Kettel
  'GBCSG1600051': 'XiXKqdVDPfA', // Vision Trail - Blue States
  'TCAAX1169063': 'KvEL3PR-8vo', // Inside Your Dream - Melorman
  'DEX260300107': 'xO6wJU03PlM', // Beacons - Icebreaker International, Manual
  'GBCQV0801524': 'SN6eEPxuTfI', // Aura Borealis - Ozric Tentacles
  'NLD7H1600063': 'g6-Wf79K_zE', // Claudia, Wilhelm R And Me - Roberto Musci
  'USCGJ1394574': 'Yeu3350YFHg', // Peaceful Heart - Reasonandu
  'CAAA11726903': 'EG6k58DLNMw', // Spirit - Jean-Michel Blais, CFCF
  'USA2P0300371': 'yxw8qmjZ1gI', // Bedtime Story - Younger Brother
  'GBCEL1700695': 'rXNPbUyiI64', // Feel First Life - Jon Hopkins

  // ============ CLOSING PHASE (26 tracks) ============
  'QMQTX1200002': 'mEV8Ey1lsGs', // Twilight - Todd Boston
  'GBBMP1200627': 'KHwzNFk-Ovk', // Hammock Therapy - Shpongle
  'GBZXS0300004': 'vVYzupMBit8', // Seeking Shelter - Alucidnation
  'uscgh1629859': 'xIbc4gSSq9c', // Inside - Trevor H Oswalt, East Forest
  'USWS41212702': '7hkfu2O1Ejs', // Nectar Drop - DJ Drez
  'uscgh1629861': 'ep0Lygra_OU', // Soul Speak - Trevor H Oswalt, East Forest
  'QM24S1902153': 'WUQkBFFML7w', // I Am Loving Awareness - East Forest, Ram Dass, Krishna Das
  'ushm21242234': 'jwCNQavg2KE', // The Other Side of the Earth - KiloWatts
  'GBEWA1400890': 'OrnnbUsn0mY', // Quieter Is Louder - Above & Beyond
  'TCACQ1670624': 'h1PWLCOHV_Y', // Threshold (feat. East Forest) - MC YOGI, East Forest
  'USWS40808313': 'GkKScsOec_4', // Shanti (Peace Out) - MC YOGI
  'US2BB1000125': 'UBczoFsxZJA', // Illumina - Deva Premal
  'AUUM71200073': '0E1bNmyPWww', // Follow The Sun - Xavier Rudd
  'GBCPA0500928': 'ROvhfxIoHRQ', // Mother - Afro Celt Sound System
  'TCADH1722665': 'megdgf0wjA8', // Madre De La Selva - Maneesh de Moor
  'USHM91455975': 'Y5udYEMLxiw', // Code of Ten - East Forest
  'GBKPL1028481': 'OBbnSWWVyrE', // The Stars In Spring - Epic45
  'GBEWA1700800': 'I49aXXi_gDU', // Surge - Above & Beyond
  'GBCKG1700232': 'eNLT5XXl-_A', // Listen to the Grass Grow - Seckou Keita, Catrin Finch
  'USWKN1200007': 'FqwOmJnGVvA', // Beauty Into Wreck - Lowercase Noises
  'GBBBC2000185': 'pTDV22Dvq7Y', // We Contain Multitudes - from home - Ólafur Arnalds
  'USA2P0502894': 'nq9-LbwqONc', // Invocation - Shpongle
  'GBAYE0601506': 'm4BuziKGMy4', // Tomorrow Never Knows - Remastered 2009 - The Beatles
  'US7LW0900001': 'IJiHDmyhE1A', // Baba Yetu - Christopher Tin, Soweto Gospel Choir
  'GBAYE0601489': 'mBqqeqcJM_0', // In My Life - Remastered 2009 - The Beatles
  'US2BB1201084': '7Mn1BB0KHrc', // Letting Go - Shaman's Dream, Bluetech
};

/**
 * Get the YouTube video ID for a given ISRC.
 * Returns undefined if no mapping exists.
 */
export function getYouTubeVideoId(isrc: string): string | undefined {
  const videoId = youtubeTrackMappings[isrc];
  return videoId && videoId.length > 0 ? videoId : undefined;
}

/**
 * Check if a track has a valid YouTube mapping.
 */
export function hasYouTubeMapping(isrc: string): boolean {
  return !!getYouTubeVideoId(isrc);
}
